import { CompareChart } from "./CompareChart";
import { UserTable } from "./UserTable";

export const ByUser = ({ data, raw, selected, setSelected, toggle, onOpen }) => (
  <div className="space-y-6">
    <CompareChart
      data={data}
      raw={raw}
      selected={selected}
      onRemove={toggle}
      onClear={() => setSelected([])}
      onTop={() => setSelected(data.users.slice(0, 5).map((u) => u.id))}
    />
    <UserTable data={data} selected={selected} onToggle={toggle} onOpen={onOpen} />
  </div>
);
